/**
 * RichText Section
 * Использует переиспользуемые компоненты
 */
import { Container } from '../components';

export default function RichText({ data, styles }) {
  const blocks = data?.blocks || [];
  const maxWidth = data?.maxWidth || 'md';
  const alignment = data?.alignment || 'left';

  const getMaxWidthClass = () => {
    switch (maxWidth) {
      case 'sm': return 'max-w-2xl';
      case 'md': return 'max-w-4xl';
      case 'lg': return 'max-w-6xl';
      case 'full': return 'max-w-full';
      default: return 'max-w-4xl';
    }
  };

  const getAlignmentClass = () => {
    return alignment === 'center' ? 'text-center' : 'text-left';
  };

  const renderBlock = (block) => {
    switch (block.type) {
      case 'h2':
        return (
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
            {block.content}
          </h2>
        );

      case 'h3':
        return (
          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
            {block.content}
          </h3>
        );

      case 'paragraph':
        return (
          <p className="text-base md:text-lg text-text-secondary leading-relaxed mb-4">
            {block.content}
          </p>
        );

      case 'bullet-list':
        return (
          <ul className="space-y-3 mb-4">
            {(block.items || []).map((item, index) => {
              const text = typeof item === 'string' ? item : item?.text;
              const details = typeof item === 'string' ? '' : item?.details;
              const hasDetails = details && details.trim();
              return (
                <li key={index} className="flex gap-3">
                  <span className="text-primary mt-1.5">•</span>
                  <div>
                    <p className={`text-base md:text-lg leading-relaxed whitespace-pre-wrap ${hasDetails ? 'text-foreground font-medium' : 'text-text-secondary'}`}>
                      {text}
                    </p>
                    {hasDetails && (
                      <p className="text-sm md:text-base text-text-secondary mt-1 whitespace-pre-wrap">
                        {details}
                      </p>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        );

      case 'numbered-list':
        return (
          <ol className="space-y-3 mb-4">
            {(block.items || []).map((item, index) => {
              const text = typeof item === 'string' ? item : item?.text;
              const details = typeof item === 'string' ? '' : item?.details;
              const hasDetails = details && details.trim();
              return (
                <li key={index} className="flex gap-3">
                  <span className="text-primary font-medium mt-0.5 min-w-[1.5rem]">
                    {index + 1}.
                  </span>
                  <div>
                    <p className={`text-base md:text-lg leading-relaxed whitespace-pre-wrap ${hasDetails ? 'text-foreground font-medium' : 'text-text-secondary'}`}>
                      {text}
                    </p>
                    {hasDetails && (
                      <p className="text-sm md:text-base text-text-secondary mt-1 whitespace-pre-wrap">
                        {details}
                      </p>
                    )}
                  </div>
                </li>
              );
            })}
          </ol>
        );

      case 'quote':
        return (
          <blockquote className="border-l-4 border-primary pl-4 py-2 mb-4 bg-muted/50 rounded-r-lg">
            <p className="text-base md:text-lg text-foreground italic">
              {block.content}
            </p>
          </blockquote>
        );

      case 'divider':
        return <hr className="border-border my-6" />;

      default:
        return null;
    }
  };

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop ?? 64,
        paddingBottom: styles?.paddingBottom ?? 64,
        backgroundColor: styles?.backgroundColor || '#FFFFFF'
      }}
    >
      <div className={`${getMaxWidthClass()} mx-auto px-4 ${getAlignmentClass()}`}>
        {blocks.map((block) => (
          <div key={block.id}>
            {renderBlock(block)}
          </div>
        ))}
      </div>
    </section>
  );
}
